import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const designationApi = createApi({
  reducerPath: 'designationApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Designation'],
  endpoints: (builder) => ({
    // Get all designations
    getDesignations: builder.query({
      query: () => '/designations',
      providesTags: ['Designation'],
    }),

    // Get designation by ID
    getDesignation: builder.query({
      query: (id) => `/designations/${id}`,
      providesTags: (result, error, id) => [{ type: 'Designation', id }],
    }),

    // Create designation
    createDesignation: builder.mutation({
      query: (designation) => ({
        url: '/designations',
        method: 'POST',
        body: designation,
      }),
      invalidatesTags: ['Designation'],
    }),

    // Update designation
    updateDesignation: builder.mutation({
      query: ({ id, ...designation }) => ({
        url: `/designations/${id}`,
        method: 'PUT',
        body: designation,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Designation', id },
        'Designation',
      ],
    }),

    // Delete designation
    deleteDesignation: builder.mutation({
      query: (id) => ({
        url: `/designations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Designation'],
    }),
  }),
});

export const {
  useGetDesignationsQuery,
  useGetDesignationQuery,
  useCreateDesignationMutation,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation,
} = designationApi;
